import React from "react";

interface Event {
  title: string;
  subject: string;
  date: string;
  time: string;
  datetime: string;
}

interface UpcomingEventsData {
  events: Event[];
}

interface UpcomingEventsProps {
  upcomingEventsData: UpcomingEventsData | null;
  loading: boolean;
}

const UpcomingEvents: React.FC<UpcomingEventsProps> = ({
  upcomingEventsData,
  loading,
}) => {
  return (
    <div className="events-section flex-grow-1 w-100 d-flex flex-column min-h-0 mt-0">
      <div className="section-header">
        <h3>Upcoming Events</h3>
        <button className="btn btn-outline-primary btn-sm all-btn">All</button>
      </div>
      <div className="events-table flex-grow-1 d-flex flex-column">
        <div className="table-header">
          <span>Event Name</span>
          <span>Date</span>
          <span>Time</span>
        </div>
        {loading ? (
          <div className="p-3 text-center">Loading events...</div>
        ) : upcomingEventsData?.events && upcomingEventsData.events.length > 0 ? (
          upcomingEventsData.events.map((event, index) => (
            <div key={index} className="table-row">
              <span>{event.title}</span>
              <span>{event.date}</span>
              <span>{event.time}</span>
            </div>
          ))
        ) : (
          <div className="no-events-message p-3 text-center text-muted">
            No upcoming events found.
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingEvents;
